import React, { useState, useEffect } from "react";
import Image from "next/image";
import profileImg from "../../../../new-images/profile/profile.svg";
import globeImg from "../../../../new-images/globe.svg";
import styles from "./EventCard.module.scss";
import { TEventData, TUser } from "../../../../stores/EventStore";
import UserAvatar from "../../../ui/userAvatar";
import redirectTo from "../../../../utils/redirectTo";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { noun, verb } from "plural-ru";
import Button from "../../ui/button/Button";

const EventCard: React.FC<{ data: TEventData }> = ({ data }) => {
  const [dateTime, setDateTime] = useState({
    date: null,
    time: null,
  });
  // set correct date and time
  useEffect(() => {
    const start = moment(data.start_date);
    const end = moment(data.end_date);
    const endDateStr = end.format(`D[\xA0]MMMM[\xA0]YYYY`);

    const eventDateTime = {
      date: [],
      time: null,
    };

    if (start.isSame(end, "day")) {
      eventDateTime.time = start.format("HH:mm") + "-" + end.format("HH:mm");
    } else if (start.isSame(end, "month")) {
      eventDateTime.date.push(start.format("D"));
    } else if (start.isSame(end, "year")) {
      eventDateTime.date.push(start.format(`D[\xA0]MMMM`));
    } else {
      eventDateTime.date.push(start.format(`D[\xA0]MMMM[\xA0]YYYY`));
    }

    eventDateTime.date.push(endDateStr);

    setDateTime({
      ...dateTime,
      date: eventDateTime.date.join(" - "),
      time: eventDateTime.time,
    });
  }, [data]);

  const getDonorsStr = () => {
    const count = data.joined_count - 2;
    const donor = noun(count, "донор", "донора", "доноров");
    const go = verb(count, "идет", "идут", "идут");

    return `и ещё ${count} ${donor} ${go}`;
  };

  return (
    <>
      {/* дата и время */}
      <div className={styles.header}>
        {dateTime.date && <span className={styles.date}>{dateTime.date}</span>}

        {dateTime.time && <span className={styles.time}>{dateTime.time}</span>}
      </div>

      <div className={styles.body}>
        <div className={styles.organizer}>
          {/* логотип организатора */}
          <Image
            src={data.author?.image || profileImg}
            loader={() => data.author?.image || profileImg}
            unoptimized={true}
            width={80}
            height={80}
            quality={50}
            alt="logo"
          />
          {/* название организатора */}
          <p className={styles.organizer__name} title={data.author?.name}>
            {data.author?.name}
          </p>
        </div>
        {/* название мероприятия */}
        <h5 className={styles.title} title={data.name}>
          {data.name}
        </h5>
        {/* партнеры мероприятия */}
        {(data.individual_partners?.length > 0 ||
          data.unity_partners?.length > 0) && (
          <div className={styles.partners}>
            <span>Партнёры мероприятия</span>

            <div className={styles.partners__list}>
              {data.individual_partners?.map((partner) => (
                <Image
                  width={32}
                  height={32}
                  key={partner?.id}
                  className={styles.HeadDate__img}
                  alt={partner?.name}
                  src={partner?.image || profileImg}
                  loader={() => partner?.image || profileImg}
                  unoptimized={true}
                  quality={10}
                ></Image>
              ))}
              {data.unity_partners?.map((partner) => (
                <Image
                  width={32}
                  height={32}
                  key={partner?.id}
                  className={styles.HeadDate__img}
                  alt={partner?.name}
                  src={partner?.image || profileImg}
                  loader={() => partner?.image || profileImg}
                  unoptimized={true}
                  quality={10}
                ></Image>
              ))}
            </div>
          </div>
        )}
        {/* адрес или онлайн */}
        {data.category?.name?.toLowerCase() === "онлайн" ? (
          // <div className={`${styles.TopContainer} ${styles.TopContainerFirst} ${styles.EventCard__status}`}>
          <div className={styles.status}>
            <Image
              className={styles.TopContainerImg}
              src={globeImg}
              width={16}
              height={16}
              alt="hospital"
            ></Image>

            <span className={styles.TopContainerText}>
              {data.category?.name}
            </span>
          </div>
        ) : data.category?.id === 1 ? (
          <p
            className={styles.address}
            title={`${data.city?.title && data.city?.title}
            ${
              data.blood_station?.address && `, ${data.blood_station?.address}`
            }`}
          >
            {data.city?.title && `${data.city?.title}`}
            {data.blood_station?.address && `, ${data.blood_station?.address}`}
          </p>
        ) : (
          <p
            className={styles.address}
            title={`${data.city?.title}
          ${data.city?.title && data.address && ","} ${data.address}`}
          >
            {data.city?.title}
            {data.city?.title && data.address && ","} {data.address}
          </p>
        )}
      </div>

      <div className={styles.footer}>
        {/* сколько доноров идет */}
        {data.joined_count > 0 && (
          <div className={styles.userList}>
            {data.joined_count > 2 ? (
              <span className={styles.userList__count}>
                {`${data.joined_users[0]?.user?.first_name}, ${
                  data.joined_users[1]?.user?.first_name
                } ${getDonorsStr()}`}
              </span>
            ) : (
              <span className={styles.userList__count}>
                {`${data?.joined_users[0]?.user?.first_name}, `}
                {data?.joined_users[1]?.user?.first_name}{" "}
                {data?.joined_count > 1 ? "уже идут" : "уже идёт"}
              </span>
            )}

            <div className={styles.userList__photos}>
              {data.joined_count > 0 &&
                data.joined_users
                  .map((user) => (
                    <UserAvatar
                      user={user.user}
                      scale={34}
                      key={user.user.id}
                    />
                  ))
                  .slice(0, 3)}{" "}
            </div>
          </div>
        )}
        <Button
          children={"Записаться"}
          onClick={() =>
            redirectTo(
              `/events/${data.id}?utm_source=profile&utm_medium=event&utm_campaign=donor_search`
            )
          }
        />
      </div>
    </>
  );
};

export default inject()(observer(EventCard));
